import React, { useState } from "react";
import FilterShell from "./FilterShell";

const defaultState = { name: "", email: "", phone: "" };

const UsersFilters = ({ onApply, initial = null }) => {
  const [data, setData] = useState({ ...defaultState, ...(initial || {}) });

  const onChange = (e) =>
    setData((d) => ({ ...d, [e.target.name]: e.target.value }));

  return (
    <FilterShell
      onApply={() => onApply(data)}
      onClear={() => {
        setData(defaultState);
        onApply(defaultState);
      }}
    >
      <div className="col-md-4">
        <label className="form-label">Name</label>
        <input
          type="text"
          name="name"
          className="form-control"
          value={data.name}
          onChange={onChange}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label">Email</label>
        <input
          type="text"
          name="email"
          className="form-control"
          value={data.email}
          onChange={onChange}
        />
      </div>
      <div className="col-md-4">
        <label className="form-label">Phone</label>
        <input
          type="text"
          name="phone"
          className="form-control"
          value={data.phone}
          onChange={onChange}
        />
      </div>
    </FilterShell>
  );
};

export default UsersFilters;
